import Block from '../block'

export default class Nav extends Block {
	static title = 'nav'

	init() {
		this.navItems = this.getElements('item')
		this.navItems.forEach(navItem => {
			const subnavId = navItem.dataset.subnavId

			if (!subnavId) {
				return
			}

			if (navItem.dataset.click) {
				navItem.addEventListener('click', () => this.setActive(subnavId))
				return
			}

			navItem.addEventListener('mouseenter', () => this.setActive(subnavId))
		})
	}

	setActive(subnavId) {
		this.eventEmitter.emit('nav:toggle-subnav', {
			subnavId: subnavId
		})
	}
}
